import React from "react";
import { NavLink } from "react-router-dom";

export default function MobileAppDevelopment() {
  return (
    <section className="container page-top pt-10" style={{ paddingTop: "6rem" }}>
      <div className="container">
        {/* Title Section */}
        <div className="row mb-4">
          <div className="col-12 text-center">
            <h1 className="display-5 fw-bold text-primary">Mobile App Design & Development</h1>
            <h5 className="text-muted">
              Intuitive, Scalable & Feature-Rich Mobile Experiences for Android and iOS
            </h5>
            <hr className="w-25 mx-auto" />
          </div>
        </div>

        {/* Image and Introduction */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6">
            <img
              src="https://img.freepik.com/free-vector/mobile-ui-ux-concept-illustration_114360-12025.jpg"
              alt="Mobile App Development"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="fw-semibold">Why Choose Our App Development Services?</h2>
            <p>
              <strong>Bytlas Intelligence</strong> delivers high-performance mobile apps tailored to your business needs. We design apps with modern UI/UX principles, robust backends, and cross-platform compatibility to maximize reach and engagement.
            </p>
            <ul className="list-group list-group-flush">
              <li className="list-group-item">✅ Android & iOS Native & Hybrid Development</li>
              <li className="list-group-item">✅ User-Centric Interface & Experience</li>
              <li className="list-group-item">✅ Real-Time Sync with Backend Systems</li>
              <li className="list-group-item">✅ Secure APIs and Data Management</li>
            </ul>
          </div>
        </div>

        {/* Features Section */}
        <div className="row my-5">
          <div className="col-md-6">
            <h3 className="text-secondary">Built for Performance & Scalability</h3>
            <p>
              Whether you're launching a startup or expanding enterprise capabilities, our mobile apps are engineered to perform—offering seamless performance under high load, instant updates, and integrated analytics.
            </p>
            <p>
              We use the latest tech stack including Flutter, React Native, and Kotlin/Swift to ensure rapid delivery and maintainability.
            </p>
          </div>

          <div className="col-md-6">
            <h3 className="text-secondary">What You Get</h3>
            <ul>
              <li>📱 Cross-platform Support</li>
              <li>⚙️ Admin Panel & Real-time Updates</li>
              <li>🔐 Secure Authentication (OTP, OAuth, Biometrics)</li>
              <li>📊 In-App Analytics Integration</li>
              <li>🧠 AI-Driven User Engagement Features</li>
            </ul>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-4">
          <NavLink to="/contact" className="btn btn-danger px-4 py-2 rounded-pill fw-bold">
            Schedule Your App Consultation
          </NavLink>
        </div>
      </div>
    </section>
  );
}
